
<div>
    <button class="left1"  mat-raised-button  (click)="CreateFolder();">
        <span class="mdc-button__label colr" >Create Folder</span>
    </button>
  
</div>
<!--------------add sub folder-------------->
<!----
<div class="card wd" *ngIf="Addsub">
    <form>
        <div class="card-body">
        <div class="form-group">
            <label>Select Folder</label>

            <select  class="form-control" style="width: 100%;" data-select2-id="1" tabindex="-1"  aria-hidden="false"  #mySelect (change)="SelectFolder(mySelect.value);">
                <option *ngFor="let item of folders"     [value]="item._id">{{item.folder_name}}</option>                   
                </select>
            </div> 

            <div class="form-group">
            <label>Sub Folder Name</label><span class="error">{{SubName}}</span>
            <input type="text" class="form-control" placeholder="Enter sub category name"  name="sub" [(ngModel)]="sub_data.sub_folder_name" (ngModelChange)="valuechange2($event)">
            </div>
            
            </div>
    
    <div class="card-footer">
    <button class="btns"  mat-raised-button (click)="AddSubFolder();">
        <span class="mdc-button__label colr" >Added</span>
    </button>
    </div>
    </form>
    </div>
    --->
<!-------------------------------------------->
<!-----------------Add folder----------------->
    
     <div class="card wd" *ngIf="CreateFolderShown">
        <form>
        <div class="card-body">
        <div class="form-group">
        <label for="exampleInputPassword1">Folder Name</label><span class="error">{{FName}}</span>
        <input type="text" class="form-control" placeholder="Folder name" name="name" [(ngModel)]="data.folder_name"  (ngModelChange)="valuechange1($event)">
        </div>

        <div class="form-group">
            <label>Parent Folder Name</label>
          <!-- <input type="text" class="form-control" placeholder="Enter sub folder name"  name="sub" [(ngModel)]="sub_data.sub_folder_name" (ngModelChange)="valuechange2($event)"> -->
           <select  class="form-control" style="width: 100%;" data-select2-id="1" tabindex="-1"  aria-hidden="false"  #mySelect (change)="SelectFolder(mySelect.value);">
            <option value="" hidden>Select folder</option>
            <option *ngFor="let item of parent" [value]="item._id">{{item.folder_name}}</option>                   
           </select> 
        </div>
            
       

        <div class="form-group">
        <label>Related Folder</label>
        <!-- <select  class="form-control" style="width: 100%;" data-select2-id="1" tabindex="-1"  aria-hidden="false"  #mySelect (change)="SelectFolder(mySelect.value);">
            <option *ngFor="let item of folders" [value]="item.folder_id">{{item.folder_name}}</option>                   
        </select> -->

        <ng-multiselect-dropdown name="rel"
        [placeholder]="'Select Folder'"
        [settings]="dropdownSettings"
        [data]="dropdownList"
        allowSearchFilter=true
        (onSelect)="onItemSelect($event)"
        (onSelectAll)="onSelectAll($event)"
        (onDeSelect)="onDeSelect($event)"
        (onUnSelectAll)="onDeSelecAll()"
        [(ngModel)]="selectedItems"
       >
       </ng-multiselect-dropdown>
        </div> 
        
        </div>
       
    <!------alert--------------
        <h1 class="msg">{{msg1}}</h1>
     -------------------->
       
        <div class="card-footer">
        <button class="btns"  mat-raised-button (click)="AddFolder();">
            <span class="mdc-button__label colr" >Added</span>
        </button>
        </div>
        </form>
        </div>
<!---------------------------------new ui---------------------------------------------------->


    <section class="content-header ">
    
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Folders</h1>
    </div>
    
    
    </div>
    </section>
    <!--------------loader-------------------------->
    <div *ngIf=loaderShown class="loader"></div>
    <!----------------------------------------------->
    
    
    <section class="content">
    
    <div class="card" *ngIf=cardShown>
    <div class="card-header">
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 35%">
    Folder Name
    </th>

    <th style="width: 35%">
     Relative Folder Name
    </th>
 
    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
    {{c.folder_name}}
    </a>
    </td>

    <td>
    {{c.relative_folder_name}}
    </td>
    <!----
        
    <td *ngIf="c.shansapp_sub_folder!=0;else noSubFolder">
        <div *ngFor="let d of c.shansapp_sub_folder">
          {{d.sub_folder_name}}
        </div>
        </td>
        <ng-template #noSubFolder>
            <td> </td>
        </ng-template>
    ---->
    <td class="project-actions text-right">
<!----
    <a class="btn btn-info btn-sm "  (click)='EditFolderSet(c._id);'>
---->
    <a class="btn btn-info btn-sm " (click)='EditFolderSet(c._id);'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
    <a class="btn btn-danger btn-sm left" data-toggle="modal" data-target="#modal-sm" (click)="SetFolderId(c._id,c.folder_name);">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
<!---------------------paging------------------------------------->
<ul class="pagination">
    <li class="paginate_button page-item previous" id="example2_previous">
    <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link count">Previous</a></li>
    
    <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link count">{{ New_count+1}}</a></li>
               
    <li class="paginate_button page-item next" id="example2_next" >
    <a  (click)="clicks_next()"  aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
    </ul>
      
    
 <!--------------------delete folder notification---------------------------------------->
<div class="modal fade" id="modal-sm" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
    <div class="modal-content">
    
    <div class="modal-body">
    <p>Delete {{deleteFolderName}}?</p>
    </div>
    <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-default" data-dismiss="modal">No</button>
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="DeleteFolder();">Yes</button>
    </div>
    </div>
    
    </div>
    
    </div>





